module.exports = __webpack_public_path__ + "img/UNION_CHANGE.ea94be0c.png";